angular.module('picmonicng').filter('slugify', function () {
  return function (input) {
    if (!input) {
      return input;
    }

    s = input
      .replace(/[^\w\s-]/g, '')
      .trim()
      .toLowerCase();
    return s.replace(/[-\s]+/g, '-');
  };
});
